export var RegistrationType;
(function (RegistrationType) {
    RegistrationType["CLIENT"] = "client";
    RegistrationType["TRUST"] = "trust";
    RegistrationType["JOINT"] = "joint";
    RegistrationType["HOUSEHOLD"] = "household";
})(RegistrationType || (RegistrationType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["ACTIVE"] = "active";
    RegistrationStatus["INACTIVE"] = "inactive";
    RegistrationStatus["LEAD"] = "lead";
    RegistrationStatus["ENGAGED"] = "engaged";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RegistrationCreationStepStatus;
(function (RegistrationCreationStepStatus) {
    RegistrationCreationStepStatus["COMPLETE"] = "complete";
    RegistrationCreationStepStatus["INCOMPLETE"] = "incomplete";
    RegistrationCreationStepStatus["SKIPPED"] = "skipped";
})(RegistrationCreationStepStatus || (RegistrationCreationStepStatus = {}));
export var RegistrationActivityType;
(function (RegistrationActivityType) {
    RegistrationActivityType["CREATED"] = "created";
    RegistrationActivityType["STATUS_UPDATED"] = "status_updated";
    RegistrationActivityType["RISK_PROFILE_UPDATED"] = "risk_profile_updated";
    RegistrationActivityType["CUSTOM_PDF_REPORT_GENERATED"] = "custom_pdf_report_generated";
    RegistrationActivityType["TRANSITION_ANALYSIS_GENERATED"] = "transition_analysis_generated";
    RegistrationActivityType["CATEGORIZED_HOLDINGS_GENERATED"] = "categorized_holdings_generated";
    RegistrationActivityType["ONE_PAGE_PDF_REPORT_GENERATED"] = "one_page_pdf_report_generated";
})(RegistrationActivityType || (RegistrationActivityType = {}));
export var RegistrationCreateOption;
(function (RegistrationCreateOption) {
    RegistrationCreateOption["REGISTRATION"] = "registration";
    RegistrationCreateOption["HOUSEHOLD"] = "household";
})(RegistrationCreateOption || (RegistrationCreateOption = {}));
export const REGISTRATION_TYPE_LABELS = {
    [RegistrationType.CLIENT]: 'Client Registration',
    [RegistrationType.JOINT]: 'Joint Registration',
    [RegistrationType.TRUST]: 'Trust Registration',
};
export const REGISTRATION_TYPE_LOGOS = {
    [RegistrationType.CLIENT]: 'icon-template-client-registration-color',
    [RegistrationType.JOINT]: 'icon-template-joint-registration-color',
    [RegistrationType.TRUST]: 'icon-template-trust-registration-color',
    [RegistrationType.HOUSEHOLD]: 'icon-portfolio-type-household',
};
export const REGISTRATION_TYPE_DESCRIPTIONS = {
    [RegistrationType.CLIENT]: 'Single Client',
    [RegistrationType.JOINT]: 'A Joint Account',
    [RegistrationType.TRUST]: 'A Trust Account',
};
export const CREATE_REGISTRATION_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Registration',
        value: RegistrationCreateOption.REGISTRATION,
        icon: 'icon-report',
    },
    {
        type: 'option',
        label: 'Household',
        value: RegistrationCreateOption.HOUSEHOLD,
        icon: 'icon-portfolio-type-household',
    },
];
export const REGISTRATION_STATUS_OPTIONS = [
    { value: RegistrationStatus.ACTIVE, label: 'Active', pillClass: 'bg-positive-8' },
    { value: RegistrationStatus.LEAD, label: 'Lead', pillClass: 'bg-gradient-2d' },
    { value: RegistrationStatus.ENGAGED, label: 'Engaged', pillClass: 'bg-yc-blue-90' },
    { value: RegistrationStatus.INACTIVE, label: 'Inactive', pillClass: 'bg-gray-base-95' },
];
export const MAX_CHILDREN = 100;
export const REGISTRATION_ACTIVITY_ICON_MAPPING = new Map([
    [RegistrationActivityType.CREATED, 'icon-activity-client-add'],
    [RegistrationActivityType.STATUS_UPDATED, 'icon-activity-client-update'],
    [RegistrationActivityType.RISK_PROFILE_UPDATED, 'icon-activity-client-update'],
    [RegistrationActivityType.CUSTOM_PDF_REPORT_GENERATED, 'icon-activity-sent'],
    [RegistrationActivityType.TRANSITION_ANALYSIS_GENERATED, 'icon-activity-sent'],
    [RegistrationActivityType.CATEGORIZED_HOLDINGS_GENERATED, 'icon-activity-sent'],
    [RegistrationActivityType.ONE_PAGE_PDF_REPORT_GENERATED, 'icon-activity-sent'],
]);
export const HOUSEHOLD_ACTIVE_TO_INACTIVE_WARNING = 'A household in an inactive state will have all of its registrations converted to an inactive state and all portfolios within those registrations will become EXTERNAL. Would you like to continue?';
export const REGISTRATION_ACTIVE_TO_INACTIVE_WARNING = 'A registration in an inactive state will have all of its portfolios converted to EXTERNAL. Would you like to continue?';
export const shareRiskProfileWarningMessage = (clientGroupName, riskProfileName) => `<strong>Warning:</strong> This Registration is already shared with ${clientGroupName}. Because the 
    ${riskProfileName} Risk Profile is not yet shared, it will be automatically shared with ${clientGroupName}`;
